import { styled } from '@abyss/web/tools/styled';
import { Badge } from '@abyss/web/ui/Badge';
import { Button } from '@abyss/web/ui/Button/v1';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';

export const LocationCardContainer = styled('div', {
  margin: '16px',
});

export const LocationCardStack = styled(Layout.Stack, {
  '&.abyss-layout-stack': {
    alignItems: 'flex-start',
    gap: '16px',
  },
});

export const LocationCardWrapper = styled('div', {
  background: '$primary2',
  cursor: 'pointer',
  width: '408px',
  textAlign: 'left',
  '@screen < $sm': {
    width: '100%',
  },
  '&.location-card-map-view': {
    minWidth: '320px',
    '.location-details': {
      '>div': {
        marginBottom: 0,
        '&:last-child': {
          marginTop: '10px',
        },
      },
    },
  },
});

export const LocationDetailsStack = styled(Flex, {
  flex: 1,
  gap: '8px',
  '>span': {
    overflowWrap: 'anywhere',
    width: '100%',
  },
});

export const LocationBadgeRow = styled(Flex, {
  height: '20px',
  gap: '16px',
  flexDirection: 'column',
});

export const MilesButton = styled('button', {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
});

export const AcceptingNewPatientsBadge = styled(Badge, {
  fontSize: '12px',
});

export const SelectLocationBadge = styled(Badge, {});

export const SelectLocationButton = styled(Button, {
  gap: '16px',
  '&.abyss-button-root': {
    padding: '4px 16px',
  },
});
